import Styles from './styles.module.css';
import Items from './1.item/index';
import SendModal from './3.send_modal/index';
import { useState, useEffect } from 'react';
import React from 'react';
import { useAppSelector } from 'src/salon/app/hook';
import { schoolList } from 'src/type';
import Confirm from './confirm/index';
import { ONBOARDING_JOB_POSTING_YEAR } from '../../2.jobPostings/jobPostingRef';

const ManualSelect: React.FC = () => {

  const [ checkList, setCheckList ] = useState<string[]>([]);
  const [ sendModal, setSendModal ] = useState<boolean>(false);
  const [ searchText, setSearchText ] = useState<string>('');

  const company = useAppSelector((state) => state.company.company);

  // オンボーディングの送付先は、直前のSTEP(1.manual/3.school)で作った求人票と同じ年度として保存する。
  const sendingYear = ONBOARDING_JOB_POSTING_YEAR;

  const filteredSchoolList = searchText === ''
    ? schoolList
    : schoolList.filter((data) => data[1].includes(searchText));

  // Windows(desktop/index.tsxで全体にzoom:0.8がかかっている)では、
  // 内側の要素がCSSのmin-height:100vhをそのまま使うとzoomで縮小された分
  // 画面下部が余って背景が途切れるため、ズーム分を逆算した高さで
  // 上書きする(desktop/index.tsxのMainラッパーと同じ対処)。
  const isWindows = navigator.userAgent.includes("Windows");

  return (
    <>
    <div className={Styles.plan} style={{ minHeight: isWindows ? '125vh' : undefined }}>
      <div className={Styles.inner}>

        <p className={Styles.kicker}>STEP 4</p>
        <h1 className={Styles.title}>送付先の学校を選択</h1>
        <p className={Styles.lead}>
          {company.contract
            ? '有料プランは全国の学校へ自動で送付されます。選択は不要です。'
            : '求人票を送る学校を10校まで選べます。'}
        </p>

        {company.contract ?
        <Confirm completePath="/service/manual/complete" />
        :
        <>
          <div className={Styles.toolbar}>
            <input
              className={Styles.search}
              type="text"
              placeholder="学校名で検索"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />

            <button
              type='button'
              className={Styles.send_jobPostings}
              disabled={checkList.length !== 10}
              onClick={() => checkList.length === 10 && setSendModal(true)}
            >
              求人票を送信する
            </button>
          </div>

          <p className={Styles.send_upper}>選択学校数：{checkList.length}校 / 10校</p>

          <div className={Styles.manage}>
            <div className={Styles.manage_header}>
              <div className={Styles.manage_table}>
                <div style={{width: '15px'}}></div>
                <p className={Styles.items_table_box_1}>学校名</p>
                <p className={Styles.items_table_box_2}>地方</p>
                <p className={Styles.items_table_box_2}>都道府県</p>
                <p className={Styles.items_table_box_3}>住所</p>
                <div style={{ flexGrow: 1 }}></div>
              </div>
            </div>

            {filteredSchoolList.map((data) =>
              <Items school={data} checkList={checkList} setCheckList={setCheckList} />
            )}
          </div>
        </> }

      </div>
    </div>

    {sendModal && company.id !== "" ?
      <SendModal companyId={company.id} year={sendingYear} schools={checkList} completePath="/service/manual/complete" setSendModal={setSendModal} setCheckList={setCheckList} />
    : <></> }
    </>
  );
}

export default ManualSelect;

